<template>
  <div id="hres62e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres62eIndex"
            searchBoxAlias="request"
            :maxRowspan="maxRowspan.index"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent"
            :unLoadBool="true" />
    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :currentDtereq="currentDtereq"
            :currentNumseq="detail.seqno"
            :currentCodempid="codempid"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :postHres62eSave="postHres62eSave"
            :indexSelected="indexSelected"
            :arrCodleave="dropdowns.codleave"
            :entitlement="entitleFlagleave.entitlement"
            :enableFlagLeave="entitleFlagleave.enableflagleave"
            :worktime="worktime"
            :receivedHres62eEntitlement="receivedHres62eEntitlement"
            :receivedHres62eWorktime="receivedHres62eWorktime"
            :searchIndex="searchIndex"
            :descCodapp="dash.descCodapp"
            :popup="popup"
            :receivedHres62ePopup="receivedHres62ePopup"
            :receivedHres62eIndex="receivedHres62eIndex"
            :receivedHres62eCodleave="receivedHres62eCodleave"
            :detailDisp="detailDisp"
            :flgQuery="flgQuery"
            :setFlgQuery="setFlgQuery" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres62e/mutation-types'
import detail from 'components/hres62e/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres62e',
  data () {
    return {
      searchIndex: {
        dtereqst: '01/01/' + moment().format('YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      currentDtereq: moment().format('DD/MM/YYYY'),
      flgQuery: false
    }
  },
  created () {
    this.receivedHres62eColumnsLabels()
    this.receivedHres62eDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES62E_INDEX_DISP,
      detailDisp: types.GET_HRES62E_DETAIL_DISP,
      maxRowspan: types.GET_HRES62E_MAX_ROWSPAN,
      columns: types.GET_HRES62E_COLUMNS,
      labels: types.GET_HRES62E_LABELS,
      index: types.GET_HRES62E_INDEX,
      indexSelected: types.GET_HRES62E_INDEX_SELECTED,
      detail: types.GET_HRES62E_DETAIL,
      dropdowns: types.GET_HRES62E_DROPDOWNS,
      entitleFlagleave: types.GET_HRES62E_ENTITLE_FLAG_LEAVE,
      worktime: types.GET_HRES62E_WORKTIME,
      popup: types.GET_HRES62E_POPUP
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          let searchParams = {
            p_dtework: moment().format('DD/MM/YYYY')
          }
          this.receivedHres62eCreate(searchParams)
          this.currentDtereq = moment().format('DD/MM/YYYY')
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.seqno) {
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.setFlgQuery(true)
            this.currentDtereq = this.indexSelected.dtereq
            let searchParams = {
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.seqno
            }
            this.receivedHres62eDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    setFlgQuery (flg) {
      this.flgQuery = flg
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          codempid: this.indexSelected.codempid,
          dtereq: this.indexSelected.dtereq,
          seqno: this.indexSelected.seqno,
          staappr: this.indexSelected.staappr
        }
        this.postHres62eCancel({ sendParams, searchIndex: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES62E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES62E_PAGE,
      receivedHres62eColumnsLabels: types.RECEIVED_HRES62E_COLUMNS_LABELS,
      receivedHres62eDropdowns: types.RECEIVED_HRES62E_DROPDOWNS,
      receivedHres62eIndex: types.RECEIVED_HRES62E_INDEX,
      receivedHres62eCreate: types.RECEIVED_HRES62E_CREATE,
      receivedHres62eDetail: types.RECEIVED_HRES62E_DETAIL,
      postHres62eSave: types.POST_HRES62E_SAVE,
      postHres62eCancel: types.POST_HRES62E_CANCEL,
      receivedHres62eEntitlement: types.RECEIVED_HRES62E_ENTITLE_FLAG_LEAVE,
      receivedHres62eWorktime: types.RECEIVED_HRES62E_WORKTIME,
      receivedHres62ePopup: types.RECEIVED_HRES62E_POPUP,
      receivedHres62eCodleave: types.RECEIVED_HRES62E_CODLEAVE
    })
  },
  components: {
    detail
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?6288ce51